jQuery(document).ready(function () {
    $('.layoutResize').remove();
    $('.googleMap,.overlaypanel').remove();

    //disable/uninstall widget
    $('[data-appname],[widget]').each(function () {
        var appName = $(this).attr('data-appname') || $(this).attr('widget');

        console.log('viewmode appName -->' + appName);

        //skip widget="#socialbutton"
        if (appName != '#socialbutton') {
            //disable app
            if (mex.appconfig && mex.appconfig[appName]) {
                if (
                    mex.appconfig[appName]['deleted_at'] &&
                    mex.appconfig[appName]['deleted_at'] != ''
                ) {
                    $(this).toggle(false);
                }
            } else {
                //uninstall app
                $(this).remove();
            }
        }
    });

    // hide #back-top first
    // attr backtotop
    // fade in #back-top
    if ($('#back-top').attr('backtotop') > 0) {
        $(function () {
            $(window).scroll(function () {
                if ($(this).scrollTop() > 100) {
                    $('#back-top').fadeIn();
                    $('#back-top').show();
                } else {
                    $('#back-top').fadeOut();
                }
            });

            // scroll body to 0px on click

            $('#back-top a').click(function () {
                $('body,html').animate(
                    {
                        scrollTop: 0,
                    },
                    1000
                );

                return false;
            });
        });
    }

    // console.log(`RVwys : `, RVwys);
    if (typeof RVwys === 'undefined') {
        const onClickWidget = $('[onclick]');
        onClickWidget.map(key => {
            const isElem = onClickWidget[key].getAttribute('onclick');
            if (isElem == 'RVwys.widget.ovewEvent(this)')
                onClickWidget[key].attributes.removeNamedItem('onclick');

            return;
        });
    }
});
